// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'hp.token';
export const REFRESH_TOKEN_COOKIE = 'hp.refreshToken';
export const BADGES_STORAGE_KEY = 'hp.badges';
export const VERSION = 'v0.1.0';
